(() => {
  const PERSONALIZATION = 'Name and/or number (+$7)';
  const PREMIUM = 'Premium (+$8)';
  const sizes = [
    ['Infant', ['0–3 months', '3–6 months', '6–12 months', '12–18 months', '18–24 months']],
    ['Toddler', ['2T', '3T', '4T', '5T']],
    ['Youth', ['XS', 'S', 'M', 'L', 'XL']],
    ['Adult', ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL']]
  ];
  class LakewoodOrder extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.item = this.querySelector('[data-item]');
      this.size = this.querySelector('[data-size]');
      this.personalization = this.querySelector('[data-personalization]');
      this.material = this.querySelector('[data-material]');
      this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.optionNames = JSON.parse(this.querySelector('[data-option-names]').textContent);
      this.personalizationIndex = this.optionNames.indexOf('Personalization');
      this.personalizationValue = this.variants.flatMap(v => v.options).find(value => value === 'Name and/or number (included)') || PERSONALIZATION;
      this.materialIndex = this.optionNames.indexOf('Material');
      this.baseVariants = this.variants.filter(v => (this.personalizationIndex < 0 || v.options[this.personalizationIndex] === 'None') && (this.materialIndex < 0 || v.options[this.materialIndex] === 'Standard'));
      const seenSets = new Set();
      this.baseVariants.forEach(v => {
        if (this.dataset.kind === 'sweatsuit') {
          const label = this.itemLabel(v);
          if (seenSets.has(label)) return;
          seenSets.add(label);
        }
        const option = document.createElement('option');
        option.value = String(v.id);
        option.textContent = `${this.itemLabel(v)} — ${v.formattedPrice}`;
        this.item.append(option);
      });
      const chosen = this.variants.find(v => String(v.id) === this.form.elements.id.value);
      const base = chosen && this.baseVariants.find(v => this.dataset.kind === 'sweatsuit' ? this.itemLabel(v) === this.itemLabel(chosen) : this.sameItem(v, chosen));
      this.item.value = base ? String(base.id) : '';
      this.setTop = this.querySelector('[data-set-top]');
      this.setTop?.addEventListener('change', () => this.update(false));
      this.item.addEventListener('change', () => this.update(true));
      this.personalization.addEventListener('change', () => this.update(false));
      this.material?.addEventListener('change', () => this.update(false));
      this.form.querySelectorAll('input').forEach(input => input.addEventListener('input', () => input.setCustomValidity('')));
      this.form.addEventListener('submit', event => this.submit(event));
      this.querySelectorAll('[data-image-url]').forEach(button => button.addEventListener('click', () => {
        const image = this.querySelector('.wr-order__image');
        image.removeAttribute('srcset');
        image.src = button.dataset.imageUrl;
        image.alt = button.querySelector('img').alt;
      }));
      this.update(true);
    }
    itemLabel(v) {
      const values = v.options.filter((_, i) => i !== this.personalizationIndex && i !== this.materialIndex);
      const label = values.join(' — ').replace(/^Default Title$/, this.dataset.productTitle);
      return this.dataset.kind === 'sweatsuit' ? label.replace(/\s*—\s*(Crewneck|Hoodie|Zip-up hoodie)/g, '') : label;
    }
    sameItem(a, b) {
      return a.options.every((value, i) => i === this.personalizationIndex || i === this.materialIndex || value === b.options[i]);
    }
    update(rebuildSizes) {
      let base = this.baseVariants.find(v => String(v.id) === this.item.value);
      if (base && this.dataset.kind === 'sweatsuit') {
        const top = this.setTop.value;
        base = this.baseVariants.find(v => this.itemLabel(v) === this.itemLabel(base) && v.options.some(o => o.includes(top))) || base;
        const three = /^3-piece/i.test(this.itemLabel(base));
        const third = this.querySelector('[data-third-piece]');
        third.hidden = !three;
        third.querySelectorAll('select').forEach(control => { control.disabled = !three; control.required = three; });
      }
      const paid = this.personalization.value !== 'none';
      const premium = this.material?.value === PREMIUM;
      const variant = base && this.variants.find(v => this.sameItem(v, base) && (this.personalizationIndex < 0 ? !paid : v.options[this.personalizationIndex] === (paid ? this.personalizationValue : 'None')) && (this.materialIndex < 0 ? !premium : v.options[this.materialIndex] === (premium ? PREMIUM : 'Standard')));
      const brandField = this.querySelector('[data-brand-field]');
      if (brandField) {
        brandField.hidden = !premium;
        brandField.querySelector('textarea').disabled = !premium;
      }
      const nameField = this.querySelector('[data-name-field]');
      const numberField = this.querySelector('[data-number-field]');
      [[nameField, ['name', 'both']], [numberField, ['number', 'both']]].forEach(([field, modes]) => {
        const active = modes.includes(this.personalization.value);
        field.hidden = !active;
        const input = field.querySelector('input');
        input.disabled = !active;
        input.required = active;
        input.setCustomValidity('');
      });
      if (this.size && rebuildSizes) {
        const previous = this.size.value;
        this.size.replaceChildren(new Option(this.messages.chooseSize, ''));
        const limitedZip = base && /^(Quarter Zip|Half Zip)$/.test(this.itemLabel(base));
        const groups = limitedZip ? [['Adult', ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL']]] : sizes;
        groups.forEach(([label, values]) => {
          const group = document.createElement('optgroup');
          group.label = label;
          values.forEach(value => group.append(new Option(`${label} ${value}`, `${label} ${value}`)));
          this.size.append(group);
        });
        if ([...this.size.options].some(option => option.value === previous)) this.size.value = previous;
      }
      const material = this.form.elements['properties[Material]'];
      if (material && base) {
        const cotton = /T-shirt$/.test(this.itemLabel(base));
        material.options[0].textContent = cotton ? this.messages.cotton : this.messages.standard;
      }
      this.currentVariant = variant;
      this.form.elements.id.value = variant ? String(variant.id) : '';
      this.querySelector('[data-submit]').disabled = !variant || !variant.available;
      if (variant) this.querySelector('[data-price]').textContent = variant.formattedPrice;
      const error = this.querySelector('[data-error]');
      error.hidden = !base || Boolean(variant && variant.available);
      error.textContent = error.hidden ? '' : this.messages.unavailable;
    }
    async submit(event) {
      event.preventDefault();
      if (this.submitting || !this.form.reportValidity() || !this.currentVariant?.available) return;
      this.form.querySelectorAll('input[type="text"], input:not([type])').forEach(input => {
        if (!input.disabled && input.required && !input.value.trim()) input.setCustomValidity(this.messages.error);
        else input.setCustomValidity('');
      });
      if (!this.form.reportValidity()) return;
      const data = new FormData(this.form);
      const quantity = Number(data.get('quantity'));
      if (!Number.isSafeInteger(quantity) || quantity < 1) return;
      const properties = {};
      for (const [key, value] of data.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && String(value).trim()) properties[match[1]] = String(value).trim();
      }
      properties.Item = this.itemLabel(this.currentVariant);
      if (this.material) properties.Material = this.material.value === PREMIUM ? PREMIUM : /T-shirt$/.test(properties.Item) ? 'Gildan cotton' : 'Standard blank';
      if (this.personalization.value !== 'none') properties.Personalization = this.personalization.value === 'both' ? 'Name and number' : this.personalization.value === 'name' ? 'Name' : 'Number';
      const button = this.querySelector('[data-submit]');
      const error = this.querySelector('[data-error]');
      this.submitting = true;
      button.disabled = true;
      button.textContent = this.messages.saving;
      error.hidden = true;
      try {
        const root = this.dataset.root.endsWith('/') ? this.dataset.root : `${this.dataset.root}/`;
        const response = await fetch(`${root}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:this.currentVariant.id,quantity,properties}]})});
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || this.messages.error);
        let notice = this.querySelector('[data-cart-success]');
        if (!notice) {
          notice = document.createElement('p');
          notice.dataset.cartSuccess = '';
          notice.setAttribute('role', 'status');
          this.querySelector('[data-submit]').after(notice);
        }
        notice.replaceChildren(document.createTextNode(`${this.messages.addedCart} `));
        const cartLink = document.createElement('a');
        cartLink.href = this.dataset.cartUrl;
        cartLink.textContent = this.messages.viewCart;
        notice.append(cartLink);
        fetch(`${root}cart.js`, {headers:{Accept:'application/json'}}).then(response => response.json()).then(cart => {
          document.querySelectorAll('.cart-bubble__text-count').forEach(count => {count.textContent = cart.item_count > 99 ? '99+' : String(cart.item_count);count.classList.toggle('hidden', cart.item_count === 0);});
          document.querySelectorAll('.cart-bubble').forEach(bubble => bubble.classList.toggle('visually-hidden', cart.item_count === 0));
        }).catch(() => {});
        this.submitting = false;
        button.disabled = !this.currentVariant?.available;
        button.textContent = this.messages.add;
      } catch (failure) {
        error.textContent = failure.message || this.messages.error;
        error.hidden = false;
        this.submitting = false;
        button.disabled = !this.currentVariant?.available;
        button.textContent = this.messages.add;
      }
    }
  }
  if (!customElements.get('lakewood-order')) customElements.define('lakewood-order', LakewoodOrder);
})();
